module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_03_6NX26_1SF_HMS.0cb182dc.jpg";